import { render, staticRenderFns } from "./ContentAvisos.vue?vue&type=template&id=a933c7aa"
import script from "./ContentAvisos.vue?vue&type=script&lang=js"
export * from "./ContentAvisos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports